import axios from './index'
import url from './url'
// 引用fetch.js
function getTask (typeOne) {
  return axios.get(`${url.wz}/public/v1/hw_TranscodingTask`, {
    params: typeOne
  })
}
function getAdvertising (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/getIndexAdsList`, {
    params: typeOne
  })
}

function getTopWebsList (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/topWangzhiList`, {
    params: typeOne
  })
}

function getModuleList1 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList1`, {
    params: typeOne
  })
}

function getModuleList2 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList2`, {
    params: typeOne
  })
}

function getModuleList3 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList3`, {
    params: typeOne
  })
}

function getModuleList4 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList4`, {
    params: typeOne
  })
}

function getModuleList5 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList5`, {
    params: typeOne
  })
}
function getModuleList6 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList6`, {
    params: typeOne
  })
}
function getModuleList7 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList7`, {
    params: typeOne
  })
}
function getModuleList8 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList8`, {
    params: typeOne
  })
}
function getModuleList9 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList9`, {
    params: typeOne
  })
}
function getModuleList10 (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/moduleList10`, {
    params: typeOne
  })
}
function searchSite (typeOne) {
  return axios.post(`${url.wz}/public/v1/daohang/queryWangzhi`,
    typeOne
  )
}
function getCategoryList (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/getCategoryList`, {
    params: typeOne
  })
}
function categoryWangzhiList (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/categoryWangzhiList`, {
    params: typeOne
  })
}
function getCateAdsList (typeOne) {
  return axios.get(`${url.wz}/public/v1/daohang/getCateAdsList`, {
    params: typeOne
  })
}
function getRuzhuStatus (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/daohang/getRuzhuStatus`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}
function ruzhuDaohang (typeOne, urlType) {
  return axios.post(
    `${url.wz}/public/v1/daohang/ruzhuDaohang?${urlType}`,
    typeOne,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}
export {
  getTask,
  getAdvertising,
  getTopWebsList,
  getModuleList1,
  getModuleList2,
  getModuleList3,
  getModuleList4,
  getModuleList5,
  getModuleList6,
  getModuleList7,
  getModuleList8,
  getModuleList9,
  getModuleList10,
  searchSite,
  getCategoryList,
  categoryWangzhiList,
  getCateAdsList,
  getRuzhuStatus,
  ruzhuDaohang
}



// WEBPACK FOOTER //
// ./src/axios/navigation.js